import HomeView from "../views/HomeView"
import { compileRoutes } from "./routes"
import HelpView from '../views/HelpView'
import PolicyView from '../views/PolicyView'
import TermsView from '../views/TermsView'
import PaymentView from '../views/PaymentView'
import StatementView from '../views/StatementView'
import ProfileView from '../views/ProfileView'
import PaymentRedirectView from '../views/PaymentRedirectView'
import PaymentActionsView from '../views/PaymentActionsView'
import UnsubscribeView from '../views/UnsubscribeView'
import {mapValues} from "lodash";

export const TitledRoutes = {
  home: {
    path: '/',
    title: 'Home'
  },
  help: {
    path: '/help',
    title: 'Help'
  },
  policy: {
    path: '/policy',
    title: 'Privacy Policy'
  },
  terms: {
    path: '/terms',
    title: 'Terms of Service'
  },
  unsubscribe: {
    path: '/unsubscribe',
    title: 'Unsubscribe'
  },
  payment: {
    path: '/payment',
    title: 'Payment'
  },
  paymentRedirect: {
    path: '/payment-redirect',
    title: 'Payment Redirect'
  },
  paymentPlanRedirect: {
    path: '/payment-plan-redirect',
    title: 'Payment Plan Redirect'
  },
  statement: {
    path: '/statement',
    title: 'Statement'
  },
  paymentPlan: {
    path: '/profile/payment-plans',
    title: 'Payment Plans'
  },
  paymentActivity: {
    path: '/profile/payment-activity',
    title: 'Payment Activity'
  },
  paymentActions: {
    path: '/payment-actions',
    title: 'Payment Actions'
  },
  profile: {
    path: '/profile/:tab?',
    title: 'Profile'
  }
};

export const Routes = mapValues(TitledRoutes, r => r.path)

compileRoutes(Routes)

export const mapRouteNameToRoute = (routeName: string): string => {
  if (routeName === 'Home') {
    return Routes.home
  } else if (routeName === 'Statement') {
    return Routes.statement
  } else if (routeName === 'Payment') {
    return Routes.paymentRedirect
  } else if (routeName === 'Profile') {
    return Routes.profile
  } else if (routeName === 'Help') {
    return Routes.help
  } else if (routeName === 'PaymentPlan') {
    return Routes.paymentPlan
  } else if (routeName === 'PaymentActivity') {
    return Routes.paymentActivity
  } else if (routeName === 'PaymentActions') {
    return Routes.paymentActions
  } else {
    return Routes.home
  }
}

export const AppRoutes = [
  {
    path: Routes.home,
    component: HomeView,
    strict: false,
    supportNoUserShort: true,
  },
  {
    path: Routes.help,
    component: HelpView,
  },
  {
    path: Routes.policy,
    component: PolicyView,
  },
  {
    path: Routes.terms,
    component: TermsView,
  },
  {
    path: Routes.unsubscribe,
    component: UnsubscribeView,
  },
  {
    path: Routes.payment,
    component: PaymentView,
  },
  {
    path: Routes.statement,
    component: StatementView,
  },
  {
    path: Routes.profile,
    component: ProfileView,
  },
  {
    path: Routes.paymentRedirect,
    component: PaymentRedirectView,
  },
  {
    path: Routes.paymentActions,
    component: PaymentActionsView,
  }
].map(r => Object.assign({
  exact: true,
  sensitive: true,
  strict: true,
}, r))
